import React from "react";
import { Routes, Route } from "react-router-dom";
import Nlp from "./pages/nlp/Nlp";
import Layout from "./pages/home/Layout/Layout";
import { ChatProvider } from "./pages/home/Layout/ChatProvider/ChatProvider";
import GoogleLogin from "./pages/login/GoogleLogin/GoogleLogin"; // ✅ Import ChatProvider

const App: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<GoogleLogin />} />
            <Route
                path="/ai-chat-admin"
                element={
                    <ChatProvider> {/* ✅ Wrap only Layout */}
                        <Layout />
                    </ChatProvider>
                }
            />
            <Route path="/nlp" element={<Nlp />} /> {/* Redirect unknown routes */}
            <Route path="*" element={<GoogleLogin />} /> {/* Redirect unknown routes */}
        </Routes>
    );
};

export default App;
